// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "smm-auth-widget." + "0dae5de2" + ".js";
};